Vue.component('ThemeChanger', require('./components/ThemeChangerComponent').default);
